module.exports = __webpack_public_path__ + "static/img/15.d68c4c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/15.png
// module id = Xlg4
// module chunks = 0